module.exports = __webpack_public_path__ + "src/assets/textures/env/hay/wagon_hay_02_1k_bake.png";